import React from "react";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import AppContainer from "components/ui/AppContainer";
import AppHeading1 from "components/ui/AppHeading1.jsx";
import AppSearchInput from "components/ui/AppSearchInput";
import AppPaginatedTable from "components/ui/AppPaginatedTable";
import AppDropDown from "components/ui/AppDropdown";
import AppIcon from "components/ui/AppIcon.jsx"
import CustomerDetailsModal from "./CustomerDetailsModal";
import AddLoyaltyPointsModal from "./CreditLoyaltyPointsModal"

const CustomersTable = ({
  customers,
  handlePageChange,
  handleSearch,
  searchTerm,
  onRefresh,
}) => {
  const { t } = useTranslation();
  const [showDetails, setShowDetail] = useState(false);
  const [showAddLoyaltyModal, setShowLoyaltyModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const items = [
    
      { 
        label:(<span className="flex items-center text-gray-600 gap-3 px-2 py-2"><AppIcon name="eye" />View Details</span>), 
        key: 'view',
      }, 
      { label:(<span className="flex items-center text-gray-600 gap-3 px-2 py-2"><AppIcon name="handStars" />Add Loyalty Points</span>), 
        key: 'points',
      },
    ];
  const viewDetail = (row) => {
    setSelectedCustomer(row);
    setShowDetail(true);
  };
  const addLoyaltyPoints = (row) => {
    setSelectedCustomer(row);
    setShowLoyaltyModal(true);
  };
    // router.push("/app/dashboard/customer-wallet-history", row);

  const renderMobileNumber = (value, row, index) => {
    return (
      <div>
        <p className="m-0" dir="ltr">
          {` +${row.countryCode}${value}`}
        </p>
      </div>
    );
  };
  const actionButton = (value, row) => {
    return (
      <AppDropDown
        icon="more"
        dropdownMenu={items}
        onItemClick={(k) => {
          if (k === "view") viewDetail(row);
          else if (k === "points") addLoyaltyPoints(row);
        }}
      />
    );
  };
  const columns = [
    {
      title: t("Customer Name"),
      dataIndex: "name",
      key: "name",
      render: (value, row, index) => {
        return (
          <div>
            <p className="m-0">{value || t("N/A")}</p>
          </div>
        );
      },
    },
    {
      title: t("Whatsapp Number"),
      dataIndex: "phoneNumber",
      key: "mobileNumber",
      render: renderMobileNumber,
    },

    {
      title: t("Lifetime Spending"),
      dataIndex: "lifetimeSpending",
      key: "lifetimeSpending",
      render: (value, row, index) => {
        return (
          <div>
            {value ? (
              <p className="m-0" dir="ltr">
                {t("AED")} {parseFloat(value)?.toFixed(2) || 0}
              </p>
            ) : (
              <p className="m-0" dir="ltr">
                {t("AED")} 0
              </p>
            )}
          </div>
        );
      },
    },

    {
      title: t("Actions"),
      dataIndex: "action",
      key: "action",
      fixed: "right",
      render: (value, row) => actionButton(value, row),
    },
  ];

  const filteredCustomers = useMemo(() => {
    const normalizedSearch = String(searchTerm || "").replace(/\D/g, "");
    if (!normalizedSearch) return customers?.data || [];

    return (customers?.data || []).filter((customer) => {
      const fullWhatsappNumber = `${customer?.countryCode || ""}${customer?.phoneNumber || ""}`.replace(/\D/g, "");
      const localWhatsappNumber = String(customer?.phoneNumber || "").replace(/\D/g, "");

      return (
        fullWhatsappNumber.includes(normalizedSearch) ||
        localWhatsappNumber.includes(normalizedSearch)
      );
    });
  }, [customers?.data, searchTerm]);

  return (
    <AppContainer title={t("Customers")} subTitle={t("Here you can track all your customer details in one place.")} containerProps={{ className: "overflow-y-hidden" }}>
      <div className="flex justify-between items-center flex-col sm:flex-row mb-5">
        <AppHeading1>Customers List</AppHeading1>
        <div className="flex flex-col sm:flex-row">
          <AppSearchInput
            value={searchTerm}
            placeholder={t("Search by whatsapp number")}
            onInput={handleSearch}
          />
        </div>
      </div>
      <AppPaginatedTable
        columns={columns}
        data={filteredCustomers}
        page={customers?.currentPage || 1}
        total={filteredCustomers?.length || 0}
        onPageChange={(page) => handlePageChange(page)}
        clientSidePagination={true}
      />
      <CustomerDetailsModal
        open={showDetails}
        customer={selectedCustomer}
        onClose={() => {
          setShowDetail(false);
          setSelectedCustomer(null);
        }}
      />
      <AddLoyaltyPointsModal
        open={showAddLoyaltyModal}
        customer={selectedCustomer}
        onClose={() => {
          setShowLoyaltyModal(false);
          setSelectedCustomer(null);
        }}
        onSuccess={() => onRefresh?.()}
      />
    </AppContainer>
  );
};

export default CustomersTable;
